import { useState, useCallback } from 'react';

export interface UseNotificationSoundReturn {
  isPlaying: boolean;
  soundEnabled: boolean;
  playNotificationSound: () => Promise<boolean>;
  playTestSound: () => Promise<boolean>;
}

export function playNotificationSound(): Promise<boolean> {
  return new Promise((resolve) => {
    const audio = new Audio('/event_alert.wav');
    audio
      .play()
      .then(() => resolve(true))
      .catch((error) => {
        console.error('Failed to play notification sound:', error);
        resolve(false);
      });
  });
}

export function useNotificationSound(): UseNotificationSoundReturn {
  const [isPlaying, setIsPlaying] = useState(false);
  const [soundEnabled, setSoundEnabled] = useState(false);

  const handlePlayNotificationSound =
    useCallback(async (): Promise<boolean> => {
      setIsPlaying(true);
      const success = await playNotificationSound();
      if (success && !soundEnabled) {
        setSoundEnabled(true);
      }
      setIsPlaying(false);
      return success;
    }, [soundEnabled]);

  const playTestSound = useCallback(async (): Promise<boolean> => {
    const success = await handlePlayNotificationSound();
    return success;
  }, [handlePlayNotificationSound]);

  return {
    isPlaying,
    soundEnabled,
    playNotificationSound: handlePlayNotificationSound,
    playTestSound,
  };
}
